export const isProduction = import.meta.env.VITE_ENVIRONMENT === "production";
export const isLocal =
  import.meta.env.VITE_ENVIRONMENT === "local" ||
  import.meta.env.VITE_ENVIRONMENT === "development";
export const isDevelopment = ["local", "stage", "development"].includes(
  import.meta.env.VITE_ENVIRONMENT,
);

/** Non-prod header badge + favicon accent. Null in production. */
interface AppEnvironmentAccent {
  label: "Dev" | "Stage";
  /** Badge text / tint color. */
  badgeColor: string;
  /** Favicon square fill. */
  faviconBackgroundColor: string;
  /** Favicon H fill. */
  faviconForegroundColor: string;
}

export const appEnvironmentAccent: AppEnvironmentAccent | null = isProduction
  ? null
  : import.meta.env.VITE_ENVIRONMENT === "stage"
    ? {
        label: "Stage",
        badgeColor: "#2563eb",
        faviconBackgroundColor: "#ffffff",
        faviconForegroundColor: "#2563eb",
      }
    : {
        label: "Dev",
        badgeColor: "#db2777",
        faviconBackgroundColor: "#15803d",
        faviconForegroundColor: "#ffffff",
      };
